import YudlButton from "../../../components/Button";
import CircleCheck from "../../../components/Icons/CircleCheck";
import { ROUTES } from "../../../constants";
import { setFormState } from "../../../redux/contact";
import { useAppDispatch } from "../../../redux/hooks";
import "./style.css";

const list = [
  "Custom UI design, prototype and testing with design suggetions",
  "Detailed product documentations, UX audit and feedback tracking",
  "A dedicated design team and design manager attached to you",
];

const GetStarted = () => {
  const dispatch = useAppDispatch();

  return (
    <section id="get-started">
      <div className="d-flex justify-content-center mt-2 mb-5">
        <YudlButton buttonRole="link" link={ROUTES.GETTING_STARTED} children="Get Started" style={{ width: "250px" }} />
      </div>
      <div className="get-started-content">
        <div className="container d-flex justify-content-center justify-content-lg-between">
          <div className="get-started-info d-flex align-items-center">
            <div className="p-3">
              <p className="display-6 text-background">Want a more customized</p>
              <p className="display-3 text-background fw-bold">DESIGN?</p>
              <p className="lead text-background">
                Get a product design team to create unique UX/UI designs for your project, based to your specifications
                and needs.
              </p>
              <p className="my-2 text-background">This includes:</p>
              {list.map((text, i) => (
                <div key={i} className="d-flex align-items-center mb-2">
                  <span className="me-4">
                    <CircleCheck />
                  </span>
                  <div className="text-background mt-1">{text}</div>
                </div>
              ))}
              <div className="d-flex justify-content-center justify-content-lg-start mt-5 mb-2">
                <YudlButton
                  onClick={() => dispatch(setFormState(true))}
                  variant="secondary"
                  children="Contact Us"
                  style={{ width: "250px" }}
                />
              </div>
            </div>
          </div>
          <div className="get-started-images d-none d-lg-flex">
            <div>
              <img src="/assets/landing/get-started-img-1.png" alt="" className="img-fluid me-2 w-100 h-100" />
            </div>
            <div>
              <img src="/assets/landing/get-started-img-2.png" alt="" className="img-fluid w-100 h-100" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetStarted;
